// extracted by mini-css-extract-plugin
export var text = "_7s-0";